import React, { Fragment, useRef, useEffect } from 'react';
import ReactMarkDown from 'react-markdown';
import { Fade } from '../../animation/animation';
import styles from './offer.module.scss';
import Typed, { TypedOptions } from 'typed.js';
import { useMediaQuery } from 'react-responsive';
import { Service } from '../../models/service.model';
import services from '../../utils/services';
import { AnimConfig } from '../../models/anim-config.model';

interface OfferProps {
	text?: string, 
	serviceList?: Service[], 
	currentService: Service | 'selection',
	commonServiceList?: Service[]
	animation: AnimConfig,
	clickOnSelectServiceBtn: (event:React.MouseEvent<HTMLElement>) => void
}

const typedOptions:TypedOptions = {
	typeSpeed: 40,
	backSpeed: 25,
	cursorChar: '│',
	loop: true,
	backDelay: 1000,
  loopCount: Infinity
};

const transformSerivces = (serviceList:Service[] | undefined) => {
	if(serviceList) return serviceList.map(service => services[service]?.accusative).join(', ');
		else return null;
}


const Offer = ({text, serviceList, currentService, commonServiceList, animation, clickOnSelectServiceBtn}:OfferProps) => {
  const typingStringRef:React.MutableRefObject<HTMLElement | null> = useRef(null);
	const fromMobile:boolean = useMediaQuery({ maxWidth: 900 });
  const maxwidth600:boolean = useMediaQuery({ maxWidth: 600 });

  const getMobileSelectionOffer = () => {
    let serviceText = services[currentService]?.accusative || "стоматологические услуги";
    return `Узнайте предварительную цену на <b>${serviceText}</b>, пройдя короткий тест за 20 сек`;
  }

	if (!text) typedOptions.strings = transformSerivces(serviceList)?.split(', ');
	
	useEffect(() => {
		if (text || (serviceList && serviceList.length < 2)) return;
		var typed:Typed | undefined;
		if (fromMobile) {
			if (typingStringRef.current) typingStringRef.current.textContent = 'стоматологические услуги, ';
		} else if (typingStringRef.current) {
      if (typedOptions.strings) {
        typingStringRef.current.textContent = '';
        typed = new Typed(typingStringRef.current as any, typedOptions);
      } else typingStringRef.current.textContent = 'стоматологические услуги, ';
		}
		return () => (fromMobile ? undefined : typed?.destroy());
	}, [fromMobile, text, currentService, serviceList]);

	return (<>
		<Fade up when={animation.active}>
			<h1 className={styles.offer}>
				{text ? 
					<ReactMarkDown 
						source={text}
						escapeHtml={false}
						renderers={{ paragraph: props => <Fragment {...props}/> }}
					/> 
					: (<>{fromMobile ? 
              <ReactMarkDown 
                source={getMobileSelectionOffer()}
                escapeHtml={false}
                renderers={{ paragraph: props => <Fragment {...props}/> }}
              />  
              : <>
                  <i>Узнайте предварительную  </i>
                  <i>цену на&nbsp;
                    {(serviceList && serviceList.length > 1) ?
                      <b ref={typingStringRef}/> : <>
                      <b 
                        onClick={clickOnSelectServiceBtn} 
                        className={commonServiceList && styles.selectServiceBtn}>
                        {services[currentService].accusative}
                      </b>&nbsp;</>
                    } 
                  </i>{maxwidth600 ? <br/> : ""}
                  <i>пройдя короткий тест за 20 сек</i>
                </>
          }</>)
				}

			</h1>
		</Fade>
	</>)
}

export default Offer;